import React from 'react';
export var InfoBubble = function InfoBubble() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.118 17H12.197V10.201H11.118V17ZM11.638 8.784C12.028 8.784 12.353 8.459 12.353 8.069C12.353 7.679 12.028 7.354 11.638 7.354C11.248 7.354 10.923 7.679 10.923 8.069C10.923 8.459 11.248 8.784 11.638 8.784Z",
    fill: "inherit",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11.5",
    stroke: "inherit",
    fill: "none"
  }));
};